import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ScheduleWidget from '../components/ScheduleWidget';

const {FiPlay, FiUsers, FiRadio} = FiIcons;

function Watch() {
  return (
    <div className="min-h-screen">
      {/* Hero Section with NYC Skyline Background */}
      <section
        className="relative h-[40vh] flex items-center justify-center"
        style={{
          backgroundImage:
            'url("https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?q=80&w=2070&auto=format&fit=crop")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-dark-bg"></div>
        <motion.div
          initial={{opacity: 0, y: 30}}
          animate={{opacity: 1, y: 0}}
          transition={{duration: 0.8}}
          className="relative z-10 text-center px-4"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Live on BoroughTV
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Tune into NYC's pulse. Real stories, real people, real time.
          </p>
        </motion.div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Live Player and Schedule */}
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Live Player */}
          <motion.div
            initial={{opacity: 0, scale: 0.95}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.8, delay: 0.2}}
            className="lg:col-span-2"
          >
            <div className="relative bg-dark-card rounded-lg overflow-hidden shadow-2xl">
              <div className="absolute top-4 left-4 z-10">
                <div className="flex items-center space-x-2 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                  <span>LIVE</span>
                </div>
              </div>
              <div style={{maxWidth: '100%', margin: '0 auto', position: 'relative', paddingBottom: '56.25%', height: 0}}>
                <iframe
                  src='https://player.viloud.tv/embed/channel/651df68dee0117592d2f77ccfbb049dd?autoplay=0&volume=1&controls=1&title=1&share=1&open_playlist=0&random=0'
                  style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}
                  frameBorder='0'
                  allow='autoplay'
                  allowFullScreen
                  title="BoroughTV Live Stream"
                />
              </div>
            </div>
          </motion.div>

          {/* Schedule Widget */}
          <motion.div
            initial={{opacity: 0, y: 30}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 0.6, delay: 0.4}}
            className="lg:col-span-1"
          >
            <ScheduleWidget />
          </motion.div>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-8 mt-12">
          <motion.div
            initial={{opacity: 0, y: 30}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 0.6, delay: 0.4}}
            className="bg-dark-card p-6 rounded-lg border border-dark-border"
          >
            <SafeIcon icon={FiPlay} className="text-3xl text-accent-blue mb-4" />
            <h3 className="text-xl font-semibold mb-3">Live Programming</h3>
            <p className="text-gray-400">
              Watch live shows, interviews, and events from across NYC's creative community.
            </p>
          </motion.div>

          <motion.div
            initial={{opacity: 0, y: 30}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 0.6, delay: 0.5}}
            className="bg-dark-card p-6 rounded-lg border border-dark-border"
          >
            <SafeIcon icon={FiUsers} className="text-3xl text-accent-blue mb-4" />
            <h3 className="text-xl font-semibold mb-3">Community Stories</h3>
            <p className="text-gray-400">
              Real people sharing authentic stories from every corner of the five boroughs.
            </p>
          </motion.div>

          <motion.div
            initial={{opacity: 0, y: 30}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 0.6, delay: 0.6}}
            className="bg-dark-card p-6 rounded-lg border border-dark-border"
          >
            <SafeIcon icon={FiRadio} className="text-3xl text-accent-blue mb-4" />
            <h3 className="text-xl font-semibold mb-3">Always On</h3>
            <p className="text-gray-400">
              24/7 streaming with fresh content, replays, and special programming.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Watch;